// IMG
import portfolio01 from '../../assets/portfolio/portfolio01.png';
import portfolio02 from '../../assets/portfolio/portfolio02.png';
import portfolio03 from '../../assets/portfolio/portfolio03.png';
import portfolio04 from '../../assets/portfolio/portfolio04.png';
import portfolio05 from '../../assets/portfolio/portfolio05.png';
import portfolio06 from '../../assets/portfolio/portfolio06.png';

export const dataImg = [
  {
    id: '1',
    preview: portfolio01,
    title: 'Lamp',
    tag: 'branding',
  },

  {
    id: '2',
    preview: portfolio04,
    title: 'Sneakers',
    tag: 'web',
  },
  {
    id: '3',
    preview: portfolio02,
    title: 'Smartwatch',
    tag: 'web',
  },

  {
    id: '4',
    preview: portfolio05,
    title: 'Label',
    tag: 'illustrations',
  },
  {
    id: '5',
    preview: portfolio03,
    title: 'Speakerphone',
    tag: 'illustrations',
  },
  {
    id: '6',
    preview: portfolio06,
    title: 'lemons',
    tag: 'branding',
  },
];
